import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingIndicatorProps, Sizes, IndicatorTheme } from './types'
import './Scss/_loading-indicator.scss'

const LoadingIndicator = ({
    text,
    size = Sizes.Large,
    hideText = false,
    theme = IndicatorTheme.Default,
    customMargins = '0',
}: LoadingIndicatorProps) => {
    const { t } = useTranslation()

    useEffect(() => {
        return () => {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'))
            })
        }
    }, [])

    function getClass(size: string): string {
        if(size === Sizes.Small) {
            return '--sm';
        }
        else if(size === Sizes.Medium) {
            return '--md';
        }
        else {
            return '--lg';
        }
    }
    return (
        <div className='loading-indicator' style={{margin: customMargins}}>
            <div className='loading-indicator__dot-container'>
                <div className={`dot1 loading-indicator__dot loading-indicator__dot${getClass(size)}`}></div>
                <div className={`dot2 loading-indicator__dot loading-indicator__dot${getClass(size)}`}></div>
                <div className={`dot3 loading-indicator__dot loading-indicator__dot${getClass(size)}`}></div>
            </div>
            {!hideText && (
                <span className={`loading-indicator__text loading-indicator__text--${theme}`}>
                    {text || t('message.loadingdata')}
                </span>
            )}
        </div>
    )
}

export default LoadingIndicator